<template>
  <v-container
    ref="scrolltarget"
    style="background-color:#f3f3f3; 
    padding:3px"
    v-scroll="onScroll"
    flat
    fluid
  >
    <v-row align="start" justify="center">
      <v-col cols="6">
        <v-img :src="$store.state.config.LogoImageUrl" contain max-height="9em"  ref="logo"></v-img>
      </v-col>
      <v-col cols="12" align="center" v-if="!menuhr">
        <v-btn @click="getmenu()">carica</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="false">
      <v-col>
        <v-switch v-model="show_images" label="Mostra immagini"></v-switch>
      </v-col>
      <v-col>
        <v-switch v-model="show_prices" label="Mostra prezzi"></v-switch>
      </v-col>
      <v-col>
        <v-switch v-model="enable_orders" label="Abilita Ordini"></v-switch>
      </v-col>
      <v-col>
        <v-switch v-model="flat_menu" label="Aspetto flat"></v-switch>
      </v-col>
      <v-col>
        <v-switch v-model="con_variazioni" label="Accetta Variazioni"></v-switch>
      </v-col>

      <v-col>
        xxxx {{$store.state.carrello.piatti.length}} xxxx
      </v-col>
      <v-col v-if="!isdirectmenu">Ospite {{nominativo}}</v-col>
      <v-col v-if="!isdirectmenu">numero ospiti: {{nospiti}}</v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="10" offset-md="1" align="center">
        <v-tabs
          background-color="transparent"
          color="primary"
          v-model="tab"
          class="elevation-2"    
          :centered="false"
          :grow="true"
          :vertical="false"
          prev-icon="mdi-arrow-left-bold-box-outline"
          next-icon="mdi-arrow-right-bold-box-outline"
          :icons-and-text="true"
          @change="selezionamenu"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab v-for="(menu,i) in menuprenotabili" :key="i" :href="`#tab-${i}`">{{ menu.descrizione }}  <v-icon>mdi-food</v-icon></v-tab>

          <v-tab-item 
          style="background-color:#f8f8f8"
          v-for="(menu,i) in menuprenotabili" :key="i" :value="'tab-' + i">
            <div v-html="menu.intestazione"></div>
            <Menu
              :menu="menu"
              :flat_menu="menu.aspettoflat =='1'"
              :show_images="menu.mostraimmagini =='1'"
              :enable_orders="menu.abilitaordini =='1'"
              :show_prices="menu.mostraprezzi =='1'"
              @ordinapiatto="ordinapiatto($event)"
              @rimuovipiatto="rimuovipiatto($event)"
            ></Menu>
            <div v-html="menu.piede"></div>

          <v-btn
            @click="prenotamenu(menu)"
            v-if="$store.state.carrello.piatti.length > 0"
            fixed
            bottom
            right

            
            color="success"
          >
            <v-icon>mdi-cart</v-icon>
            CONFERMA {{menu.tipo}} {{totale_carrello.quantita}} portate<span v-if="show_prices">, {{totale_carrello.totale}}€</span>
          </v-btn>

          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>

<!--
    <v-row>
      <v-col
        cols="12"
        md="10"
        offset-md="1"
        v-for="menu in menuhr.menu"
        :key="menu.descrizione"
        align="center"
      >
        {{menu.descrizione||"Menu"}}
        <Menu
          :menu="menu"
          :flat_menu="flat_menu"
          :show_images="show_images"
          :enable_orders="enable_orders"
          :show_prices="show_prices"
          @ordinapiatto="ordinapiatto($event)"
          @rimuovipiatto="rimuovipiatto($event)"
        ></Menu>
      </v-col>
    </v-row>
-->

    <v-row>
      <v-col></v-col>
    </v-row>

<!--
    <v-row >
      <v-col  align="stretch">
        <v-btn
          @click="prenota"
          v-if="$store.state.carrello.piatti.length > 0"
          fixed
          bottom
          
          color="success"
        >
          <v-icon>mdi-cart</v-icon>
          CONFERMA {{totale_carrello.quantita}} portate<span v-if="show_prices">, {{totale_carrello.totale}}€</span>
        </v-btn>
      </v-col>
    </v-row>
    -->

    <v-dialog max-width="800px" scrollable v-model="mostraconto">
      <v-card ma-3>
        <v-card-title>
          <h2>Il tuo ordine</h2>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">Portata</v-col>
            <v-col justify="end" align="end" cols="2" v-if="show_prices">Importo</v-col>
          </v-row>
          <v-row v-for="(riga) in righeordine" :key="riga.idpiatto">
            <v-col cols="6">
              <span style="font-size:1.1em">{{riga.length}} {{riga[0].descrizione}}</span>
            </v-col>
            <v-col cols="2" justify="end" align="end">
              <span v-if="show_prices" style="font-size:1.1em">{{ riga.length * riga[0].prezzo/100}}</span>
            </v-col>
            <v-col justify="end" align="end" cols="2">
              <v-btn fab small color="red" @click="rimuovipiatto(riga[0])">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </v-col>
            <v-col justify="end" align="end" cols="2">
              <v-btn fab small color="orange" @click="ordinapiatto(riga[0])">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="show_prices" cols="8" justify="end" align="end">
              <h2>Totale: {{totale_carrello.totale}}€</h2>
            </v-col>
          </v-row>
          <v-row v-if="$store.state.reservation.id!='0' && !isdirectmenu">
            <v-col>
              <v-combobox
                :items="stanze"
                item-value="RoomID"
                item-text="Descrizione"
                v-model="stanzamenu"
                label="stanza"
                @change="getturni()"
              ></v-combobox>
            </v-col>
          </v-row>
          <v-row v-show="false">
            <v-col>
              <v-combobox :items="tipiprenotazione" v-model="tipoprenotazione" label="Consegna"></v-combobox>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" v-show="turni.length > 0">
            
            <template v-for="turno in turni">
                <v-col  v-if="turno.TipoPasto == currentmenu.tipo"  :key="turno.IdTurno" align="center" justify="center">
                  <v-btn 
                 
                  @click="turnocorrente = turno" 
                  :color="turno==turnocorrente?'primary':'grey'">{{turno.TipoPasto}} del {{turno.DataPrenotazione}} </v-btn> 
                </v-col>
            </template>


          </v-row>        
          <v-row v-if="false">
            <v-col>
              <v-textarea v-model="annotazioni" label="Annotazioni"></v-textarea>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col align="center" justify="center">
              <v-btn v-if="turnocorrente && turnocorrente.PastoPrenotato ==0" @click="inviaordine" color="success">CONFERMA</v-btn>
              <h3 v-if="turnocorrente && turnocorrente.PastoPrenotato > 0">Hai già prenotato</h3>
              <v-btn v-if="turnocorrente && turnocorrente.PastoPrenotato > 0" @click="mostraconto =false" color="secondary">chiudi</v-btn>
                
             </v-col>

          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="colorenotifica" :timeout="2000">
      <v-icon v-if="erroreordine==''">mdi-check</v-icon>
      {{erroreordine!=''?erroreordine:'Ordine inserito'+erroreordine}}
    </v-snackbar>
  </v-container>
</template>

<script>
import Menu from "../components/menu/Menu.vue";

// eslint-disable-next-line no-unused-vars
function groupBy(xs, key) {
  
  console.log("GROUPBY",xs, key);
  if(Array.isArray(xs)){
    return xs.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }
  else{
    var r =[];
    r[key] = xs;
    return r;
  }

}

export default {
  components: {
    Menu
  },
  methods: {
    prenota(){
      this.getturni()
      this.mostraconto=true
    },
    prenotamenu(menu){
      this.currentmenu = menu;
      this.getturni()
      this.mostraconto=true
    },
    selezionamenu() {
      //var y = x.replace("tab-", "");

      //this.currentmenu = this.menuhr.menu[y];
      this.$store.dispatch("azzeramenu")
    },
    refreshmenu(){
      var m  = this.menuhr.menu;
      this.menuhr.menu =null;
      this.menuhr.menu =m;
    },
    cambiacolori() {
      console.log("applica colore");
      this.$vuetify.theme.isDark = false;
      this.$vuetify.theme.themes.light.primary = this.$store.state.config.ThemeColor;
    },
    getmenu: function() {
      // verifico se l'utente ha una prenotazione hotel runner
      if (this.$store.state.reservation.id != "0") {
        this.nospiti = this.$store.state.reservation.visitors.length + 1;
        if (
          this.$store.state.reservation &&
          this.$store.state.reservation.mainguest     
        ) {
          this.nominativo = this.$store.state.reservation.mainguest.firstName;
          this.tipoprenotazione ="Pasto"

          if(this.$store.state.reservation.other){
            if(this.$store.state.reservation.other.risorse.length > 0){
                this.stanzamenu = this.$store.state.reservation.other.risorse[0]
                //this.getturni()
            }
          }

        }
      } else {
        var itemId = this.$route.params.reservationid;
        if (!itemId) {
          itemId = this.$store.getters.reservationid;
        }
        if (itemId) {
          //se ho un id ma non ho ancora caricato la prenotazione
          this.$store.dispatch("setreservation", itemId).then(a => {
            this.nominativo = this.$store.state.reservation.ref;
            if (
              this.$store.state.reservation &&
              this.$store.state.reservation.mainguest
            ) {
              this.nominativo = this.$store.state.reservation.mainguest.firstName;
              this.tipoprenotazione ="Pasto"
              if(this.$store.state.reservation.other){
                if(this.$store.state.reservation.other.risorse.length > 0){
                    this.stanzamenu = this.$store.state.reservation.other.risorse[0]
                  }
              }
            }
            this.nospiti = a.visitors.length + 1;
          });
        }
      }

      const payload = {
        Comando: "GetMenuRistorante"
      };
      console.log(payload);
      const me = this;

      //Carico configurazione da hotel runner
      this.$store
        .dispatch("APIRequestHR", { Comando: "GetDatiConfigCO" })
        .then(x => {
          console.log("GetDatiConfigCO", x);
          this.$store.commit("SET_CONFIG2", x.data.RISULTATOJSON.ElencoConfig);
          this.cambiacolori();
        });

      this.$store.dispatch("APIRequestHR", payload).then(risp => {
        console.log("xmenu",risp);
        if (risp.statusText == "OK") {
          me.menuhr = risp.data.RISULTATOJSON;
          
          me.menuhr.menu.forEach(menu => {
            menu.nospiti = this.nospiti;
            menu.carrello = this.carrello;
            console.log("elemento", menu);
          });
        }
      });
    },

    getmenudiretto: function() {
      this.isdirectmenu = true;
      this.tipiprenotazione= [ "InSala", "Asporto" ]
      const payload = {
        Comando: "GetMenuGUID"
      };
      console.log(payload);
      const me = this;

      //Carico configurazione da hotel runner
      this.$store
        .dispatch("APIRequestHR", { Comando: "GetDatiConfigCO" })
        .then(x => {
          console.log("GetDatiConfigCO", x);
          this.$store.commit("SET_CONFIG2", x.data.RISULTATOJSON.ElencoConfig);
          this.cambiacolori();
        });

      this.$store.dispatch("setappmenuvisibleAction", false).then(() => {
        this.$store.dispatch("APIRequestHR", payload).then(risp => {
          console.log(risp);
          if (risp.statusText == "OK") {
            me.menuhr = risp.data.RISULTATOJSON;



          }
        });
      });
    },
    getturni: function() {
      const payload = {
        Comando: "GetTurniRistorante",
        IdMenu:this.currentmenu?this.currentmenu.idmenu:'',
        IdRisorsaPren: this.stanzamenu.RoomID
      };
      console.log(payload);
      const me = this;

        this.$store.dispatch("APIRequestHR", payload).then(risp => {
          
          if (risp.statusText == "OK") {
            me.turni = risp.data.RISULTATOJSON.ListaPasti;
            if(me.turni && me.turni.length > 0){
              console.log("TURNI:",me.turni);
              me.turni.forEach(turno => {
                console.log("TURNO:",turno,me.currentmenu);
                  if(turno.TipoPasto == me.currentmenu.tipo){
                    
                    me.turnocorrente = turno
                  }
              });
              
            }

          }
        });
    },

    ordinapiatto(piatto) {
      this.$store.dispatch("ordinapiatto", piatto)
    },

    rimuovipiatto(piatto) {
      this.$store.dispatch("rimuovipiatto", piatto)
    },

    aggiornasottogruppi(obj) {
      console.log("aggiornasottogruppi", obj);
      if (obj["sottogruppi"]) {
        obj["sottogruppi"].forEach(sottogruppo => {
          
          sottogruppo.ordinato = 0;
          if(sottogruppo.piatti){
            sottogruppo.piatti.forEach(piatto=>{
                piatto.ordinato =0;
                if(piatto.sottogruppo){
                    let bkp = piatto.sottogruppo.idsottogruppo;
                    piatto.sottogruppo.idsottogruppo = -1;
                    piatto.sottogruppo.idsottogruppo = bkp;
                  }
                });
          }

          console.log("aggiornasottogruppo",sottogruppo);
          if (sottogruppo["sottogruppi"]) {
            this.aggiornasottogruppi(sottogruppo["sottogruppi"]);
          }
        });
      }
    },
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;

      //console.log('scrolling',this.$refs.scrolltarget)
    },
    inviaordine() {
      this.erroreordine = "";
      let ordine = {
        IdConto: "",
        NumeroCoperti: this.nospiti,
        Nominativo: this.nominativo,
        EMail: "mariorossi@mail.it",
        Telefono: "",
        Indirizzo: "",
        DataPrenotazione: "2020-05-30 11:30",
        IdTerminale: this.$store.state.fcmtoken,
        TipoPrenotazione: this.tipoprenotazione,
        IdRisorsaPren: this.stanzamenu?this.stanzamenu.RoomID:"",
        TipoPasto: this.currentmenu.tipo,
        IdTurno:this.turnocorrente?this.turnocorrente.IdTurno:"",
        IdMenu:this.currentmenu?this.currentmenu.idmenu:"",
        Piatti: [
          {
            IdPiatto: "1251",
            Quantita: "3",
            Prezzo: "1250",
            Portata: "1",
            Descrizione: ""
          }
        ]
      };

      ordine.Piatti = [];
      this.$store.state.carrello.piatti.forEach(element => {
        ordine.Piatti.push({
          IdPiatto: element.idpiatto,
          Quantita: "1",
          Prezzo: element.prezzo,
          Portata: element.portata,
          Descrizione:element.variazioni,
          IdRaggruppamento: element.idsottogruppo,
          Note:element.variazioni,
        });
      });

      let payload = {
        Comando: "AddOrdinazioneRisto",
        Ordinazione: ordine
      };

      this.$store.dispatch("APIRequestHR", payload).then(risp => {
        console.log(risp.data);
        this.erroreordine = risp.data.ERRORE;
        this.snackbar = true;
        
          if (risp.data.RISPOSTAOK==-1 && risp.statusText == "OK") {
            //me.menuhr = risp.data.RISULTATOJSON;
            this.mostraconto = false
            this.snackbar = true
            //this.carrello.piatti=[]
            //this.aggiornasottogruppi(this.currentmenu)
            this.$store.dispatch("azzeramenu")
          }
          else{
            //this.erroreordine = risp.data
            this.snackbar = true
          }
        
      });
    },
    async setReservationid(apiurl, id) {
        this.idprenotazione = id

         await this.$store.dispatch("setreservation", id).then(a=>{
            console.log("Reservation SETTO:", a)
            this.cambiacolori();  
            
            /*for (const key in this.$store.getters.privacyfinalita) {
                const element = this.$store.getters.privacyfinalita[key];
                this.consensiprivacy.push(element);
            }*/

         })

        console.log("setreservationid", id);
      }
  },
  computed: {
    menuprenotabili(){
        return this.menuhr.menu.filter(x=>x.prenotabile=='1');
    },
    colorenotifica(){
      console.log('err',this.erroreordine,this.erroreordine!=''?'success':'red')
      return this.erroreordine!=''?'red':'success'
    },
    righeordine() {
      return groupBy(this.$store.state.carrello.piatti, "idpiatto");
      //return this.$store.state.carrello.piatti;
    },
    stanze() {
      return this.$store.state.reservation.other.risorse;
    },
    totale_carrello() {
      let totale = 0;
      this.$store.state.carrello.piatti.forEach(element => {
        console.log(element);
        totale += Number(element.prezzo);
      });
      return { totale: totale / 100, quantita: this.$store.state.carrello.piatti.length };
    }
  },
  mounted() {

      var itemId = this.$route.params.reservationid;
      if(itemId){
        var apiurl = this.$store.state.settings.apiurl;
        console.log("carico prenotazione", itemId,apiurl);
        if(itemId){
          this.setReservationid(apiurl, itemId);
        }
      }

    this.guidmenu = this.$route.params.guidmenu;
    console.log("GUIDMENU:", this.guidmenu);
    if (this.guidmenu) {
      this.$store.dispatch("setguidmenuAction", this.guidmenu).then(() => {
        this.getmenudiretto();
      });
    } else {
      this.getmenu();
    }
  },
  data: () => ({
    variazioni:[],
    turni:[],
    con_variazioni:true,
    isdirectmenu:false,
    snackbar:false,
    erroreordine: null,
    tab: null,
    menuhr: null,
    mostraconto: false,
    enable_orders: true,
    show_images: false,
    flat_menu: true,
    show_prices: true,
    sheet: true,
    guidmenu: null,
    stanzamenu: null,
    nospiti: 20,
    nominativo: "",
    tipoprenotazione: "InSala",
    annotazioni: "",
    offsetTop: 0,
    carrello: {
      piatti: []
    },
    turnocorrente:null,
    tipiprenotazione: ["Domicilio", "InSala", "Asporto", "Pasto"],
    currentmenu: {
      id: "m1",
      titolo: "PRANZO",
      data: "21/05/2000",
      portate: [
        {
          descrizione: "primi",
          piatti: [
            {
              id: 1,
              descrizione: "spaghetti al pomodoro",
              immagine:
                "https://images.lacucinaitaliana.it/wp-content/uploads/2015/07/10025843/Spaghetti-al-pomodoro-1600x800.jpg",
              ingredienti: ["pasta", "pomodoro", "basilico", "sale"],
              prezzo: 7.5
            },
            {
              id: 2,
              descrizione: "risotto ai funghi",
              immagine:
                "https://www.lospicchiodaglio.it/img/ricette/risottofunghi.jpg",
              ingredienti: ["riso", "funghi porcini", "prezzemolo", "sale"],
              prezzo: 9.5
            }
          ]
        },
        {
          descrizione: "secondi",
          piatti: [
            {
              id: 1,
              descrizione: "arista al forno",
              immagine:
                "https://www.napolimilionaria.it/wp-content/uploads/2020/02/ricetta-arista-di-maiale.jpg",
              ingredienti: ["maiale", "pepe", "sale", "olio e.v.o."],
              prezzo: 7.5
            },
            {
              id: 2,
              descrizione: "branzino al sale",
              immagine:
                "https://wips.plug.it/cips/buonissimo.org/cms/2012/06/branzino-al-sale.jpg?w=712&a=c&h=406",
              ingredienti: ["branzino", "sale", "olio e.v.o."],
              prezzo: 9.5
            }
          ]
        }
      ]
    }
  })
};
</script>